module.exports = __webpack_public_path__ + "img/5.08de400d.png";